import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-back-to-work-dummy',
  standalone: true,
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyComponent {}
